import { LiFiToolLogo } from '../icons/lifi.js';
export const defaultCoinbaseConfig = {
    appName: 'LI.FI',
    appLogoUrl: LiFiToolLogo,
};
//# sourceMappingURL=coinbase.js.map